export default {
  name: 'Fragment',

  componentName: 'Fragment',

  functional: true,

  render(h, ctx) {
    return ctx.children
  }
}
